var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ColumnChart',{attrs:{"title":'Aylık Ciro Grafiği',"description":'Ay bazlı ciro değişim grafiği',"columnChartOptions":_vm.monthGiroDistributionDataChartOptions,"loading":_vm.monthGiroDistributionDataLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }